import { createContext, useContext, useEffect, useState } from "react";
import { where, query, collection, getDocs } from "firebase/firestore";
import { db } from "../Config/firebase";
import useConsolidatedActions from "../Development/pages/Actions/useConsolidatedActions";
import { AuthContext } from "./AuthContext";
import { getAllProjects } from "../Config/db/project.retrieve";

export const ProjectContext = createContext();

export const ProjectContextProvider = ({ children }) => {
  const { userInfo } = useContext(AuthContext);
  const [allProjects, setAllProjects] = useState([]);
  const [projectInfo, setProjectInfo] = useState(null);
  const [participants, setParticipants] = useState(null);

  const { reports, actions, estimatedToResolve } =
    useConsolidatedActions(projectInfo);

  const refreshProjects = () => {
    if (userInfo?.communityCode) {
      getAllProjects(userInfo.communityCode, (projects) => setAllProjects(projects));
    }
  };

  useEffect(() => {
    refreshProjects();
  }, [userInfo]);

  const createOrLoadDiscussion = async (
    navigate,
    path,
    communityCode,
    projectData
  ) => {
    setProjectInfo(projectData);
    const particpatnsSnap = await getDocs(
      query(
        collection(db, "users"),
        where("communityCode", "==", communityCode)
      )
    );
    const participants = {};
    particpatnsSnap.forEach((participant) => {
      const obj = participant.data();
      participants[obj.uid] = obj;
    });
    setParticipants(participants);
    if (path) {
      navigate(path);
    }
  };

  const activeProjects = allProjects.filter((t) => t.status !== "resolved" && t.status !== "closed");
  const inActiveProjects = allProjects.filter((t) => t.status === "resolved" || t.status === "closed");

  return (
    <ProjectContext.Provider
      value={{
        projectInfo,
        setProjectInfo,
        participants,
        createOrLoadDiscussion,
        reports,
        actions,
        estimatedToResolve,
        allProjects,
        activeProjects,
        inActiveProjects,
        refreshProjects,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
